export const FEEDBACK_REVIEW_SESSION_KEY = 'feedback-review-dismissed';
